import { nanoid } from '@reduxjs/toolkit';

/** Разделитель для уникального идентификатора инициализации формы */
export const FORM_INITIALIZATION_ID_SEPARATOR = '#';

/**
 * Создает уникальный идентификатор инициализации формы из formId и uniquePart
 * @param formId - идентификатор формы
 * @param uniquePart - уникальная часть идентификатора инстанса
 * @returns уникальный идентификатор в формате "formId#uniquePart"
 * @example createFormInitializationId('myForm', 'abc123') // 'myForm#abc123'
 */
function createFormInitializationId(formId: string, uniquePart: string): string {
    return `${formId}${FORM_INITIALIZATION_ID_SEPARATOR}${uniquePart}`;
}

/**
 * Генерирует новый уникальный идентификатор инициализации формы
 * @param formId - идентификатор формы
 * @returns новый уникальный идентификатор в формате "formId#uniquePart"
 * @example generateNewFormInitializationId('myForm') // 'myForm#abc123xyz'
 */
export function generateNewFormInitializationId(formId: string): string {
    const newUniquePart = nanoid();
    return createFormInitializationId(formId, newUniquePart);
}
